export function getFilenameFromContentDisposition(header) {
  if (!header) return null;

  // Try filename* first (RFC 5987)
  const filenameStar = header.match(/filename\*\s*=\s*[^']*''([^;\n]+)/i);
  if (filenameStar) {
    return decodeURIComponent(filenameStar[1]);
  }

  // Then fallback to filename
  const filename = header.match(/filename\s*=\s*"?(.*?)"?$/i);
  if (filename) {
    return filename[1];
  }

  return null;
}
